import './biebelscatering1/style';
import FormStructure from './biebelscatering1/form_structure';

export default FormStructure;